import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fef5b8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "There is no payment history to display.", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 2,
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "Restart Subscription", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Do you want to restart your subscription? You will be billed at the end of your current billing period.")
], -1))
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "Confirm Subscription Cancellation", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Are you sure you want to cancel all Ditto subscriptions for this organization? The cancellation will be effective at the end of your current billing period. You will lose access to Ditto at that time.")
], -1))
const _hoisted_11 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_CancelFlowModal = _resolveComponent("CancelFlowModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.invoices || (_ctx.invoices && _ctx.invoices.length == 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 1,
          data: _ctx.paymentData,
          ref: "paymentTable",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "date",
              label: "Date",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "description",
              label: "Charge"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tooltip, {
                  placement: "top-start",
                  "show-after": "500"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.description), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.description), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "Amount",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, " $" + _toDisplayString(scope.row.amount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "Status",
              sortable: ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                (scope.row.success)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: scope.row.receipt_URL,
                      target: "_blank",
                      and: "",
                      rel: "noopener noreferrer"
                    }, _toDisplayString(scope.row.isInvoice ? 'Invoice' : 'Receipt'), 9, _hoisted_4))
                  : (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 1,
                      placement: "top-start",
                      "show-after": "250"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(scope.row.failureMessage), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(scope.row.failureMessage), 1)
                      ]),
                      _: 2
                    }, 1024))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.isLoading]
        ]),
    (_ctx.isSubscriptionActive || _ctx.cancelDevMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.isCanceled)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "mt-4",
                type: "primary",
                onClick: _ctx.onClickRestart
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Restart Subscription")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_loading, _ctx.isLoading]
              ])
            : _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                class: "mt-4",
                type: "danger",
                onClick: _ctx.onCanelClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel Subscription")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_loading, _ctx.isLoading]
              ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.restartModalVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.restartModalVisible) = $event))
    }, {
      title: _withCtx(() => [
        _hoisted_6
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restartModalVisible=false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.restartSubscription
          }, {
            default: _withCtx(() => [
              _createTextVNode("Yes")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.cancelModalVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cancelModalVisible) = $event))
    }, {
      title: _withCtx(() => [
        _hoisted_9
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelModalVisible=false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Nevermind")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.cancelSubscription
          }, {
            default: _withCtx(() => [
              _createTextVNode("Yes")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_CancelFlowModal, {
      modelValue: _ctx.cancelFlowVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cancelFlowVisible) = $event)),
      isPO: _ctx.isPO,
      billingInterval: _ctx.billingInterval,
      subscription: _ctx.subscription,
      onCancelled: _ctx.onFlowCancelled
    }, null, 8, ["modelValue", "isPO", "billingInterval", "subscription", "onCancelled"])
  ]))
}